import { gql } from '@apollo/client';

export default gql`
  mutation CreateProductFeatureProductMutation(
    $productFeatureProduct: ProductFeatureProductInput!
  ) {
    createProductFeatureProduct(
      input: { productFeatureProduct: $productFeatureProduct }
    ) {
      productFeatureProduct {
        id
      }
    }
  }
`;
